'use strict';

function directive ($document) {
    return {
        restrict: 'E',
        link
    };

    function link (scope, element, attrs) {
        let script = $document[0].createElement('script');
        script.setAttribute('src', attrs.src);
        element[0].appendChild(script);
    }
}

directive.$inject = [
    '$document'
];

export default directive;
